
import React, { useState, useRef } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import { forgotpassword, login } from "../../actions/auth";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://lines.ac/">
        https://lines.ac/
      </Link>{' '}{new Date().getFullYear()}
      <br></br>
      Created by{' '}
      <Link color="inherit" href="https://www.netbee.be/">
        Netbee
      </Link>{' '}
    </Typography>
  );
}

export default function SignIn() {

  const form = useRef();
  const checkBtn = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector(state => state.message);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    dispatch(forgotpassword(email))
      .then(() => {
        setLoading(false);
        navigate("/");
      })
      .catch(() => {
        toast.error(
          `An error has occurred.`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
        );
        setLoading(false);
      });
  };
  
  const handleBack = (event) => {
    event.preventDefault();
    navigate("/");
    
  };

  if (isLoggedIn) {
    navigate("/")
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/lines.png`}
          alt="lines"
          height={300}
          className="lines"
        />

        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            value={email}
            onChange={onChangeEmail}
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3}}
            onClick={handleSubmit}>
            
            Submit
          </Button>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2}}
            onClick={handleBack}>
            
            Back
          </Button>
          {loading ?
            <Box
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CircularProgress />
            </Box> : <></>
          }

        </Box>
      </Box>
      <Copyright sx={{ mt: 15, mb: 4 }} />
    </Container>
  );
}